import { css } from "@emotion/css";
import { InlineMessage } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { useMutation } from "@octopusdeploy/octopus-react-client";
import type { MachineResource } from "@octopusdeploy/octopus-server-client";
import { EndpointsHelper } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { FormSection } from "~/components/form";
const styles = {
    versionContainer: css({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: space[8],
    }),
};
interface CalamariDetailsProps {
    machine: MachineResource;
}
export function CalamariDetails({ machine }: CalamariDetailsProps) {
    const { navigate } = useSpaceAwareNavigation();
    const { execute: upgradeCalamari, isExecuting: isUpgrading } = useMutation({
        name: "Upgrade Calamari",
        action: (repo) => repo.Tasks.createUpdateCalamariOnTargetTask(machine),
        afterComplete: async (_, createdTask) => navigate(links.taskPage.generateUrl({ taskId: createdTask.Id })),
    });
    if (!EndpointsHelper.UsesCalamari(machine.Endpoint.CommunicationStyle)) {
        return null;
    }
    const calamariVersionDisplay = machine.HasLatestCalamari ? ("Latest") : (<span className={styles.versionContainer}>
            Running older version
            <InlineMessage type="information" title="New version available" description="" action={{
            label: "Upgrade now",
            onClick: isUpgrading ? undefined : upgradeCalamari,
        }}/>
        </span>);
    return (<section>
            <FormSection title="Calamari Version" help={calamariVersionDisplay} includeBorder={true}/>
        </section>);
}
